import api from './api';
import { User } from '../types';

export const authService = {
    // Standard username/password login
    login: async (credentials: any): Promise<any> => {
        const response = await api.post('/auth/login', credentials);
        if (response.data.access_token) {
            localStorage.setItem('token', response.data.access_token);
        }
        return response.data;
    },

    // Initiate Facebook Link (if logged in)
    connectFacebook: (userId: string) => {
        window.location.href = `${api.defaults.baseURL}/auth/facebook?userId=${userId}`;
    },

    // Initiate Facebook Login (Direct - optional)
    loginWithFacebook: () => {
        window.location.href = `${api.defaults.baseURL}/auth/facebook`;
    },

    // Get current user profile
    getCurrentUser: async (): Promise<User> => {
        const response = await api.get('/auth/me');
        return response.data;
    },

    // Logout
    logout: () => {
        localStorage.removeItem('token');
        window.location.href = '/login';
    },
};
